<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-header-txt">{{ $t('add_user') }}</span>
        </div>

        <div class="add-user-container">
          <div class="form-row">
            <input
                type="text"
                class="form-input"
                :placeholder="$t('enter_user_e_mail')"
                v-model="inviteData.email"
                tabindex="1"
            />
            <input
                type="text"
                class="form-input"
                :placeholder="$t('enter_name')"
                v-model="inviteData.name"
                tabindex="2"
            />
            <input
                type="text"
                class="form-input"
                :placeholder="$t('enter_surname')"
                v-model="inviteData.surname"
                tabindex="3"
            />
          </div>

          <div class="form-row">
            <SelectBox
                class="select-box select-box-small"
                :options="selectboxOptions"
                :on-select="handleInviteSelect"
                :selected-value="inviteData.roleId"
                :placeholder="$t('select_a_role')"
                tabindex="4"
            />

            <multiselect
                class="select-box select-box-large"
                v-model="inviteData.departmentIds"
                :options="filteredDepartmentOptions"
                track-by="value"
                label="text"
                :multiple="true"
                :placeholder="$t('select_a_department')"
                tabindex="5"
                :internal-search="false"
                @search-change="onDepartmentSearch"
            >
              <template #noOptions>
                <span class="no-data-found">{{$t('no_data_found')}}</span>
              </template>
            </multiselect>

            <div class="btn-style-add" @click="onInvite" tabindex="6">
              <span class="btn-txt-add" v-if="!addLoading">{{ $t('add') }}</span>
              <VueSpinnerIos v-if="addLoading" size="20" height="100%" color="#fff"/>
            </div>
          </div>
        </div>

        <div class="import-csv-div">
          <div class="import-toggle" @click="csvImport = !csvImport">
            <button class="csv-button">
              <a href="https://ibilityapp.com/csv/importUsers.csv" target="_blank" download="importUsers.csv">{{$t('download_csv')}}</a>
              <img src="@/assets/images/arrow-down-blue.svg" @click.stop="downloadCsv">
            </button>
            <span>{{ $t('or_import_csv') }}</span>
            <img src="@/assets/images/chevronDownBlue.svg" />
          </div>

          <Transition name="slide-up">
            <div v-if="csvImport" class="import-csv-div">
              <FileDrop :on-file-selected="onFileSelected" type="allFiles"/>

              <button class="dark-button-sm" @click="inviteImport">
                {{ $t('import') }}
              </button>
            </div>
          </Transition>
        </div>

        <div class="btn-div2">
          <div v-if="addMultipleUsers" class="btn-style" @click="this.addMultiple">
            <span class="next-txt">{{$t('multiple_assign')}}</span>
          </div>

        </div>

        <SuccessModal :is-Visible="showSuccessModal" :on-close="onClose" :on-action="onClose"/>
        <div @click="this.onHide" class="close-btn">
          <img class="cross" src="../../assets/images/cross.svg"/>
        </div>
      </div>
    </div>
  </Transition>

  <ConfirmDeleteModal
      :title="this.$t('alert_messages')"
      :message="this.$t('alert_messages_two')"
      :is-visible="deleteModalVisible"
      :on-action="onDeleteInvite"
      :on-close="handleDeleteModalClose"
  />
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import SelectBox from "@/components/SelectBox.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import inviteService from "@/service/inviteService";
import {
  VueSpinnerIos
} from 'vue3-spinners'
import {handleErrorResponse} from "@/utils/utils";
import ConfirmDeleteModal from "@/components/modals/ConfirmDeleteModal.vue";
import FileDrop from "@/components/FileDrop.vue";
import roleService from "../../service/roleService";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    FileDrop,
    ConfirmDeleteModal,
    SuccessModal,
    TextInput,
    SelectBox,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {
      }
    },
    companyId: {
      type: String,
      default: null
    },
    roleList: {
      type: Array,
      default: []
    },
    deps: {
      type: Array,
      default: []
    }
  },

  computed: {
    getUserId() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user.userId;
    },
    filteredDepartmentOptions() {
      if (!this.departmentSearchQuery) {
        return this.selectboxOptions2;
      }
      const query = this.departmentSearchQuery.toLocaleLowerCase('tr');
      return this.selectboxOptions2.filter(option =>
        option.text && option.text.toLocaleLowerCase('tr').includes(query)
      );
    }
  },

  data() {
    return {
      filteredUsers:[],
      searchQuery: "",
      isExpanded: false,
      assignIds: [],
      addMultipleUsers: null,
      addLoading: false,
      isModalVisible: false,
      showSuccessModal: false,
      deleteModalVisible: false,
      csvImport: false,
      isLoading: true,
      currentPage: 1,
      userId: 0,
      csvFile: null,
      selectboxOptions: [],
      selectboxOptions2: [],
      usersData: [],
      inviteData: {
        name:"",
        surname:"",
        email: "",
        roleId: "",
        departmentId: "",
        departmentIds: [],
      },
      departmentSearchQuery: '',
    };
  },

  mounted() {
  },

  watch: {
    visible(newVal) {
      if (newVal && this.companyId) {
        this.initData();
      }
    },
    companyId(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.initData();
      }
    },
    roleList: {
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          this.selectboxOptions = newVal.map(role => ({
            text: role.name,
            value: role.id,
          }));
        }
      },
      deep: true,
      immediate: true,
    },
    deps: {
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          this.selectboxOptions2 = newVal.map(dep => ({
            text: dep.name,
            value: dep.departmentId,
          }));
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    onDepartmentSearch(query) {
      this.departmentSearchQuery = query;
    },
    initData() {

      this.selectboxOptions = this.roleList.map(role => ({
        text: role.name,
        value: role.id,
      }));

      if (this.companyId === null || this.companyId === undefined) {
        this.$snackbar.add({
          text: this.$t('company_id_not_set'),
          type: 'error',
        });
        this.onClose();
        return;
      } else {

        inviteService.getInvitedUsers(1, this.companyId).then(response => {
          this.usersData = response.data;

          this.usersData.forEach(user => {
            if (user.departmentIds) {
              const departmentUUIDs = user.departmentIds.map(dep => dep.uuid);
              user.departmentIds = this.selectboxOptions2.filter(option =>
                  departmentUUIDs.includes(option.value)
              );
            } else {
              user.departmentIds = [];
            }
          });

          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
        });
      }

      this.selectboxOptions = this.roleList.map(role => ({
        text: role.name,
        value: role.id,
      }));

      this.selectboxOptions2 = this.deps.map(dep => ({
        text: dep.name,
        value: dep.departmentId,
      }));
    },
    resetSearch(){
      this.searchQuery = "";
      this.filteredUsers=[];
    },

    handleInviteSearch() {
      const query = this.searchQuery.toLowerCase().trim();
      this.filteredUsers = this.usersData.filter(user =>
          user.email.toLowerCase().includes(query)
      );
    },
    updateUserDeps(user){
      user.departmentIds.push(this.addMultipleUsers);
    },
    removeUserDeps(user) {
      user.departmentIds = user.departmentIds.filter(dep => dep.value !== this.addMultipleUsers.value);
    },
    addMultiple(){
      for(const assign of this.assignIds){
        const matchedUser = this.usersData.find(user => user.userId === assign.userId);
        let departmentUUIDs = matchedUser.departmentIds.map(dep => dep.value);
        departmentUUIDs = [...new Set(departmentUUIDs)];
        const updateData = {
          userId: matchedUser.userId,
          roleId: matchedUser.roleId,
          departmentIds: departmentUUIDs
        };

        roleService.updateUserRole(updateData).then(response => {
          this.$snackbar.add({
            text: response.data.message,
            type: 'success',
          })
        }).catch(error => {
          this.$snackbar.add({
            text: this.$t('error_updating_user_group'),
            type: 'error',
          });
        });
      }
      this.assignIds=[];
    },
    checkUser(user) {
      if (!this.assignIds.map(item => item.userId).includes(user.userId)) {
        this.assignIds.push({
          userId: user.userId,
          roleId: user.roleId
        });
        this.onDepartmentIdsChanged(this.addMultipleUsers, user.userId)
      }
    },
    isSelected(id) {
      return this.assignIds.map(item => item.userId).includes(id);
    },
    isPartOfDep(id) {
      return id.includes(this.addMultipleUsers);
    },
    getUserInitials(name) {
      return name.substr(0, 1).toUpperCase();
    },

    onFileSelected(file) {
      this.csvFile = file;
    },

    onClose() {
      this.showSuccessModal = false;
    },
    onSuccessModalClose() {
      this.showSuccessModal = false;
    },
    onSave() {
      this.showSuccessModal = true;
      event.stopPropagation();
    },
    handleInviteSelect(value) {
      this.inviteData.roleId = value;
    },
    handleRoleSelectByUser(value, user) {
      user.isChanged = (user?.oldRoleId ?? false) !== value;
      if (!user.oldRoleId) {
        user.oldRoleId = JSON.parse(JSON.stringify(user)).roleId;
      }
      user.roleId = value;
    },

    onDepartmentIdsChanged(value, user) {
      user.isChanged = (user?.oldDepartmentIds ?? false) !== user.newDepartmentIds;
      if (!user.oldDepartmentIds) {
        user.oldDepartmentIds = JSON.parse(JSON.stringify(user)).departmentIds;
      }
      user.departmentIds = value;
    },

    handleDepartmentSelect(value) {
      this.inviteData.departmentId = value;

      const dept = this.selectboxOptions2.find(opt => opt.value === value);
      if (dept) {
        this.inviteData.departmentIds = [dept];
      } else {
        this.inviteData.departmentIds = [];
      }
    },

    onInvite() {
      if (this.inviteData.email === ""  || this.inviteData.name === "" || this.inviteData.surname === "") {
        this.$snackbar.add({
          text: this.$t('please_enter_user_details'),
          type: 'error',
        });
        return;
      }

      const tempData = {
        ...this.inviteData,
        companyId: this.companyId,
        departmentIds: this.inviteData.departmentIds.map(dep => dep.value)
      }

      this.addLoading = true;

      inviteService.inviteUser(tempData).then(response => {
        this.showSuccessModal = true;

        this.inviteData.email = "";
        this.inviteData.roleId = "";
        this.inviteData.name = "";
        this.inviteData.surname = "";
        this.inviteData.departmentId = "";
        this.inviteData.departmentIds = [];

        this.addLoading = false;

        inviteService.getInvitedUsers(1, this.companyId).then(response => {
          this.usersData = response.data.data.data;

          this.usersData.forEach(user => {
            if (user.departmentId && !user.departmentIds) {
              const dept = this.selectboxOptions2.find(opt => opt.value === user.departmentId);
              user.departmentIds = dept ? [dept] : [];
            } else if (!user.departmentIds) {
              user.departmentIds = [];
            }
          });

          this.$emit('user-added');
        });

      }).catch(error => {
        this.addLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    downloadCsv(event) {
      event.preventDefault();

      const link = document.createElement('a');
      link.href = 'https://ibilityapp.com/csv/importUsers.csv';
      link.download = 'importUsers.csv';
      link.click();
    },

    showDeleteModal(id) {
      this.userId = id;
      this.deleteModalVisible = true;
      event.stopPropagation();
    },
    handleDeleteModalClose() {
      this.deleteModalVisible = false;
    },
    onDeleteInvite() {
      inviteService.deleteInvite(this.userId).then(() => {
        inviteService.getInvitedUsers(1, this.companyId).then(response => {
          this.usersData = response.data.data.data;

          this.usersData.forEach(user => {
            if (user.departmentId && !user.departmentIds) {
              const dept = this.selectboxOptions2.find(opt => opt.value === user.departmentId);
              user.departmentIds = dept ? [dept] : [];
            } else if (!user.departmentIds) {
              user.departmentIds = [];
            }
          });

          this.deleteModalVisible = false;
        }).catch(() => {
          this.$snackbar.add({
            text: this.$t('error_deleting_user'),
            type: 'error',
          });
        });
      });
    },

    loadMore() {
      if (!this.lastPage && !this.isLoading) {
        this.isLoading = true;
        this.currentPage++;
        this.loadScroll();
      }
    },

    loadScroll() {
      inviteService.getInvitedUsers(this.currentPage, this.companyId).then(response => {
        this.data = response.data;
        if (response.data.data.last_page === this.currentPage) {
          this.lastPage = true;
        }

        const newUsers = response.data.data.data;

        newUsers.forEach(user => {
          if (user.departmentId) {
            const dept = this.selectboxOptions2.find(opt => opt.value === user.departmentId);
            user.departmentIds = dept ? [dept] : [];
          } else {
            user.departmentIds = [];
          }
        });

        this.usersData = [...this.usersData, ...newUsers];
        this.isLoading = false;
      }).catch(error => {
      });
    },

    updateRole(user) {
      const departmentIds = user.departmentIds.map(dep => dep.value);

      const updateData = {
        userId: user.userId,
        roleId: user.roleId,
        departmentIds: departmentIds
      };

      roleService.updateUserRole(updateData).then(response => {
        this.$snackbar.add({
          text: response.data.message,
          type: 'success',
        })
        user.isChanged = false;
        delete user.oldRoleId;
      }).catch(error => {
        this.$snackbar.add({
          text: this.$t('error_updating_user_role'),
          type: 'error',
        });
      });
    },

    inviteImport() {
      let data = {
        companyId: this.companyId,
        attach: this.csvFile
      };
      roleService.inviteImport(data).then(response => {
        this.$snackbar.add({
          text: response.data.message,
          type: 'success',
        })
      }).catch(error => {
        this.$snackbar.add({
          text: this.$t('error_importing_users'),
          type: 'error',
        });
      });
    }

  },

};
</script>

<style scoped>


.search-wrapper img {
  margin-left: 10px;
}

.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross {
  padding: 8px;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}

.modal-header-txt {
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.btn-style {
  display: flex;
  border-radius: 24px;
  background: #040C2D;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 48px;
  cursor: pointer;
}

.btn-style-add {
  display: flex;
  border-radius: 8px;
  background: #1C3CD5;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: 80px;
  max-width: 120px;
  height: 48px;
  cursor: pointer;
  flex: 0 0 auto;
  padding: 0 20px;
}

.btn-txt-add {
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  white-space: nowrap;
}

.next-txt {
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.btn-div2 {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  flex-direction: row;
  gap:10px
}

.add-user-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
  width: 100%;
}

.form-row {
  display: flex;
  flex-direction: row;
  gap: 14px;
  align-items: center;
  width: 100%;
}

.form-row,
.form-row .select-box {
  flex: 1;
  min-width: 0;
}

.import-csv-div {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  width: 100%;
  margin-top: 5px;
}

.import-toggle {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.import-toggle img {
  width: 10px;
  height: 10px;
}

.import-toggle span {
  font-family: euclid_regular, sans-serif;
  color: #1C3CD5;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
}

.csv-button{
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  padding: 10px 0 10px 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}

.csv-button a{
  background: transparent;
  padding: 10px 0 10px 10px;
  font-size: 14px;
  color: #1C3CD5;
}

@media (max-width: 768px) {
  .add-user-container {
    flex-direction: column;
  }

  .form-row {
    flex-direction: column;
    align-items: stretch;
  }

  .form-row > * {
    width: 100% !important;
    max-width: 100% !important;
  }

  .btn-style-add {
    max-width: 100% !important;
  }
}

@media (max-width: 498px) {

  .btn-style {
    width: 50%;
  }
}

:deep(.multiselect__placeholder) {
  color: #666;
  font-size: 14px;
  margin-bottom: 0;
  padding-top: 0;
  padding-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

.select-box-small {
  flex: 0 0 20%;
  min-width: 0;
  max-width: 20%;
}

.select-box-large {
  flex: 0 0 70%;
  min-width: 0;
  max-width: 70%;
}

.btn-style-add {
  flex: 0 0 auto;
  width: auto;
  min-width: 80px;
  max-width: 120px;
  padding: 0 20px;
}

@media (max-width: 999px) and (min-width: 769px) {
  .form-row {
    flex-wrap: wrap;
  }

  .select-box-small {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .select-box-large {
    flex: 0 0 70%;
    max-width: 70%;
  }

  .btn-style-add {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    margin-top: 10px;
  }
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .select-box-small,
  .select-box-large {
    flex: 1;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
  }

  .btn-style-add {
    flex: 1;
    max-width: 100% !important;
    width: 100%;
    margin-top: 10px;
  }
}

@media (max-width: 498px) {
  .btn-style {
    width: 100%;
  }
}
:deep(.select-box-small .select-custom span) {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
</style>
